import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserStatus } from '../../../store/actions';
import { buildPaginationData } from '../../../utility/utils';
import OptionalPagination from '../../pagination/OptionalPagination';
import { Card, CardContent } from "../../ui/card";
import UsersActivitiesTable from '../../tables/UsersActivitiesTable';
import ActivitiesTableFilter from '../../tables-filters/ActivitiesTableFilter';
import RefreshButton from '../../refresh-button';
import TestSlideout from '../TestSlideout';

const Network = ({ userId, history }) => {
  const dispatch = useDispatch();
  const [sortBy, setSortBy] = useState(null);
  const [filter, setFilter] = useState(null);

  const {data, loading: isLoading} = useSelector((state) => state.UserStatus);

  const [isTestSlideoutOpen, setIsTestSlideoutOpen] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);

  const fetchData = (page = null) => {
    let queryParams = {};

    if (page) {
      queryParams.page = page;
    }

    if (sortBy) {
      queryParams.sort_by = sortBy;
    }

    if (filter) {
      queryParams = {...queryParams, ...filter};
    }

    dispatch(fetchUserStatus(history, userId, queryParams));
  };

  const onFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  useEffect(() => {
    if (filter) {
      fetchData();
    }
  }, [filter]);

  const onTableSortChange = (sortBy) => {
    if (sortBy) {
      setSortBy(sortBy, () => fetchData());
    }
  };

  let paginationData = null;
  if (data?.user_activities?.length > 0) {
    paginationData = buildPaginationData(data);
  }

  const navigateToPage = (page) => {
    fetchData(page);
  };

  useEffect(() => {
    if (userId && !data?.user_activities?.length) {
      dispatch(fetchUserStatus(history, userId));
    }
  }, [userId]);

  const handleOpenTestSlideout = (test) => {
    setSelectedTest(test?.test_id);
    setIsTestSlideoutOpen(true);
  }

  const handleCloseTestSlideout = () => {
    setSelectedTest(null);
    setIsTestSlideoutOpen(false);
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="mb-4 flex flex md:flex-row flex-col gap-2 justify-between items-center">
          <div className="flex items-center gap-3 md:mb-0 mb-4">
            <h3 className="font-semibold text-lg">
              Log Entries
            </h3>
            <RefreshButton onRefresh={fetchData} />
          </div>
          <ActivitiesTableFilter
            onFilterChange={onFilterChange}
            userId={+userId}
          />
        </div>
        <div className="overflow-x-auto">
          <UsersActivitiesTable
            userId={+userId}
            data={data?.user_activities}
            isLoading={isLoading}
            onSortChange={onTableSortChange}
            allowTestDetailsDrawer={false}
            handleRowClick={handleOpenTestSlideout}
          />
          <OptionalPagination
            items={data?.user_activities}
            paginationData={paginationData}
            navigateTo={navigateToPage}
          />
        </div>
      </CardContent>

      {/* Test Slideout */}
      <TestSlideout
        isOpen={isTestSlideoutOpen}
        testId={selectedTest}
        onClose={handleCloseTestSlideout}
      />
    </Card>
  );
};

export default Network;
